import React, {useEffect, useState} from 'react'
import BreadCrumb from '../../ass_components/BreadCrumb'
import { useSelector } from 'react-redux';
import Meta from '../../ass_components/Meta'
import ReactMarkdown from "react-markdown";
import { translate } from '../../i18n';

const PaymentPolicy = () => {
    // Language setup
    const language_code = useSelector((state) => state.lang)
    const [accountSecurityPoliciesText, setAccountSecurityPoliciesText] = useState('');

    useEffect(() => {

        const filePath = language_code.lang === 'FR'
            ? './text-contents/footer-texts/policies/payment-policies/payment-policies-fr.md'
            : './text-contents/footer-texts/policies/payment-policies/payment-policies-en.md';

        fetch(filePath)
            .then((response) => {

                if (!response.ok) {
                    throw new Error('Failed to load policy text');
                }
                return response.text();
            })
            .then((text) => setAccountSecurityPoliciesText(text))
            .catch((error) => {
                console.error('Error loading policy text:', error);
                setAccountSecurityPoliciesText('Erreur de chargement de la politique.');
            });
    }, [language_code]);
    return (
        <>
            <Meta title={"Details"}/>
            <BreadCrumb title="Contenu d'article"/>
            <div className='wishlist-wrapper assiganto-home-wrapper-2 py-5'>
                <div className='container-xxl'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='policy'>
                                <div className="policy-markdown-container">
                                    <div className='login-picto'>
                                        <img src='images/core_images/assiganto-picto.png'
                                             className='img-fluid'
                                             alt='small-banner'
                                             onContextMenu={(e) => e.preventDefault()} // prevent right-click
                                             draggable="false" // prevent drag
                                             style={{ userSelect: 'none', pointerEvents: 'auto' }}
                                        />
                                    </div>
                                    <div className="policy-markdown">
                                        <center><h5>{translate('footer', language_code.lang).content_labels.content_label_8}</h5></center>
                                        <br/>
                                        <ReactMarkdown>{accountSecurityPoliciesText}</ReactMarkdown>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PaymentPolicy